import { render, staticRenderFns } from "./BbHorizontalSlider.vue.html?vue&type=template&id=6e64f99d&scoped=true&"
import script from "./BbHorizontalSlider.component.js?vue&type=script&lang=vueJs&"
export * from "./BbHorizontalSlider.component.js?vue&type=script&lang=vueJs&"
import style0 from "./BbHorizontalSlider.scoped.scss?vue&type=style&index=0&id=6e64f99d&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e64f99d",
  null
  
)

export default component.exports